import React, { ReactNode } from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  organisationByIdSelector,
  workspaceByIdSelector,
  isOrgLegacyActive,
  getOrganisationsSettingsUrl
} from '@futrli/shared-services';

import { StoreState } from '../../../core/types';
import { useOrganisationManagementRoutes } from '../../../predict-management/hooks/useOrganisationManagementRoutes';

import styles from '../../../core/common.scss';

interface Props {
  workspaceId: string;
  organisationId: string;
  children?: ReactNode;
}

export const Detail: React.FC<Props> = (): JSX.Element => {
  const location = useLocation();
  const { routes, redirect } = useOrganisationManagementRoutes();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';

  const { workspace, organisation } = useSelector((store: StoreState) => {
    const { normalised } = store;
    return {
      workspace: workspaceByIdSelector(normalised, workspaceId),
      organisation: organisationByIdSelector(normalised, workspaceId, organisationId)
    };
  });

  const isLegacyActive = organisation && workspace ? isOrgLegacyActive(organisation, workspace) : false;

  if (isLegacyActive) {
    return <Navigate to={getOrganisationsSettingsUrl(workspaceId)} replace />;
  }

  return (
    <div className={styles.detailsSection}>
      <Routes>
        {routes.map(({ name, route, component: Component }) => (
          <Route key={name} path={route} element={<Component />} />
        ))}
        {redirect && <Route path="*" element={<Navigate to={`${location.pathname}${redirect.to}`} replace />} />}
      </Routes>
    </div>
  );
};
